import React, { useState } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext'; 
import api from '../api/api'; 

const Login = () => {
    const navigate = useNavigate();
    const { login: authLogin } = useAuth(); 
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(false);
    const [dados, setDados] = useState({ login: '', senha: '' });
    const [erro, setErro] = useState('');

    const verificado = searchParams.get('verificado');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setDados(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true); 
        setErro('');

        try {
            const response = await api.post('/public/login', dados);
            
            const { Token, role } = response.data; 

            if (Token) {
                authLogin(dados.login, role, Token); 

                if (role === 'ASSINANTE') {
                    navigate('/dashboard');
                } else if (role === 'ADMIN') {
                    navigate('/admin');
                } else {
                    navigate('/');
                }
            } else {
                setErro("Erro interno: Token não recebido.");
            }
        } catch (error) {
            console.error("Erro no login:", error);
            setErro("Login ou senha inválidos.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                
                {/* BOTÃO DE VOLTAR PARA A HOME */}
                <div style={{ textAlign: 'left' }}>
                    <button onClick={() => navigate('/')} style={styles.btnVoltar}>
                        ← Voltar para a Home
                    </button>
                </div>

                <h2 style={styles.title}>
                    Acesse o <span className="text-gradient" style={{ color: '#10b981' }}>QuitaGo</span>
                </h2>
                
                {verificado && (
                    <p style={styles.successMsg}>✓ E-mail verificado! Faça login para continuar.</p>
                )}

                <form onSubmit={handleSubmit} style={styles.form}>
                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Usuário</label>
                        <input 
                            type="text" 
                            name="login" 
                            required 
                            onChange={handleChange} 
                            style={styles.input} 
                            placeholder="Seu login" 
                        />
                    </div>

                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Senha</label>
                        <input 
                            type="password" 
                            name="senha" 
                            required 
                            onChange={handleChange} 
                            style={styles.input} 
                            placeholder="••••••••" 
                        />
                    </div>

                    {erro && <p style={styles.errorMsg}>{erro}</p>}

                    <button type="submit" disabled={loading} style={styles.button}>
                        {loading ? 'Autenticando...' : 'Entrar'}
                    </button>
                </form>

                <p style={styles.footerText}>
                    Ainda não tem conta? <Link to="/registrar" style={styles.link}>Crie uma agora</Link>
                </p>
            </div>
        </div>
    );
};

const styles = {
    container: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#020617',
        padding: '20px'
    },
    card: {
        background: 'rgba(255, 255, 255, 0.03)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        padding: 'clamp(20px, 5vw, 40px)', // Responsivo: diminui o padding no celular
        borderRadius: '16px',
        maxWidth: '400px',
        width: '100%',
        backdropFilter: 'blur(10px)',
        textAlign: 'center',
        boxSizing: 'border-box' // Garante que a tela não quebre horizontalmente
    },
    
    // Estilo do botão de voltar
    btnVoltar: { 
        background: 'transparent', 
        color: '#94a3b8', 
        border: 'none', 
        cursor: 'pointer', 
        fontSize: '0.95rem', 
        marginBottom: '20px', 
        padding: 0, 
        display: 'inline-block', 
        textAlign: 'left',
        transition: 'color 0.2s'
    },

    title: {
        fontSize: '2rem',
        fontWeight: '800',
        marginBottom: '25px',
        color: 'white'
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        textAlign: 'left'
    },
    inputGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
    },
    label: {
        color: '#f8fafc',
        fontSize: '0.9rem',
        fontWeight: '600'
    },
    input: {
        background: 'rgba(255, 255, 255, 0.05)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '8px',
        padding: '12px',
        color: 'white',
        outline: 'none',
        fontSize: '1rem',
        width: '100%',
        boxSizing: 'border-box' // Mantém o input dentro dos limites
    },
    button: {
        background: '#10b981',
        color: '#022c22',
        padding: '15px',
        borderRadius: '8px',
        border: 'none',
        fontWeight: '800',
        fontSize: '1rem',
        cursor: 'pointer',
        marginTop: '10px',
        transition: '0.3s',
        width: '100%'
    },
    successMsg: {
        color: '#10b981',
        background: 'rgba(16, 185, 129, 0.1)',
        padding: '10px',
        borderRadius: '8px',
        fontSize: '0.9rem',
        marginBottom: '20px'
    },
    errorMsg: {
        color: '#ef4444',
        fontSize: '0.85rem',
        marginTop: '-10px'
    },
    footerText: {
        marginTop: '25px',
        color: '#94a3b8'
    },
    link: {
        color: '#10b981',
        textDecoration: 'none',
        fontWeight: '600'
    }
};

export default Login;